export function getUsuarioActivo() {
	try {
		const data = sessionStorage.getItem(process.env.REACT_APP_VARIABLE_SESION_STORAGE);
		if (!data) return null;

		let user;
		try {
			user = JSON.parse(data);
		} catch (e) {
			// Si no es JSON, podría ser solo el UID como string plano
			// En este caso, retornar null para que el AuthContext maneje la recarga de datos
			console.warn('sessionStorage contiene solo UID, se necesitan datos completos');
			return null;
		}
		
		// Verificar que el usuario tenga las propiedades necesarias
		if (user && user.id && user.perfil) {
			return user;
		}
		
		// Si los datos están incompletos, retornar null para forzar recarga
		console.warn('Datos de usuario incompletos en sessionStorage');
		return null;
	} catch (e) {
		console.error('Error obteniendo usuario activo', e);
		return null;
	}
}
